var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineWalletSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C4A56D09-075B-4320-8A8B-48CE64F48442") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money",
    transform: "translate(-620.000000, -188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet-search",
    transform: "translate(620.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,22.75 C11.59,22.75 11.25,22.41 11.25,22 C11.25,21.59 11.59,21.25 12,21.25 L17,21.25 C19.5799999,21.25 21.25,19.5799999 21.25,17 L21.25,12 C21.25,9.71000004 19.829999,8 17.7099991,7.75 L17,7.75 L7,7.75 C6.72,7.75 6.62000245,7.75 6.44000244,7.80999756 C6.39000244,7.82999756 6.34000092,7.84002686 6.29000092,7.84002686 C4.08000088,8.10002685 2.75,9.6500001 2.75,12 L2.75,13 C2.75,13.41 2.41,13.75 2,13.75 C1.59,13.75 1.25,13.41 1.25,13 L1.25,12 C1.25,8.94000006 3.13000083,6.72998536 6.04000092,6.35998535 C6.42000091,6.25 6.69999999,6.25 7,6.25 L17.8000031,6.25 C20.8000031,6.59999999 22.75,8.91000009 22.75,12 L22.75,17 C22.75,20.4400001 20.4400001,22.75 17,22.75 L12,22.75 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66983616,7.62999296 C5.46983616,7.42999296 5.39983586,7.12997344 5.48983587,6.85997343 C5.64983586,6.38997343 5.93983462,6.10000762 6.26983464,5.77000761 L9.45983696,2.47996867 C11.1098369,0.829968691 13.8898367,0.829958916 15.5298367,2.4699589 L17.3298397,4.27000761 C17.9898397,4.93000764 18.4098388,5.83996117 18.5398388,6.90996122 C18.5698388,7.11996122 18.4998385,7.33998808 18.3598385,7.49998808 C18.2198385,7.65998808 18.0098409,7.74998808 17.7998409,7.74998808 L6.99983799,7.74998808 C6.71983799,7.74998808 6.61984044,7.74998564 6.43984044,7.80998564 C6.35984044,7.83998564 6.27983494,7.84996367 6.19983494,7.84996367 C5.99983494,7.84996367 5.80983616,7.76999296 5.66983616,7.62999296 Z M16.8498363,6.24998808 C16.7298364,5.92998809 16.5398345,5.61000517 16.2698345,5.33000517 L14.4698391,3.53001738 C13.399839,2.46001732 11.5998367,2.46001732 10.5298367,3.53001738 L7.8898375,6.24998808 L16.8498363,6.24998808 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,17.25 C17.48,17.25 16.25,16.02 16.25,14.5 C16.25,12.98 17.48,11.75 19,11.75 L22,11.75 C22.41,11.75 22.75,12.09 22.75,12.5 C22.75,12.91 22.41,13.25 22,13.25 L19,13.25 C18.31,13.25 17.75,13.81 17.75,14.5 C17.75,15.19 18.31,15.75 19,15.75 L22,15.75 C22.41,15.75 22.75,16.09 22.75,16.5 C22.75,16.91 22.41,17.25 22,17.25 L19,17.25 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84960938,18.2000122 C1.84960938,16.0200121 3.61961389,14.25 5.79961395,14.25 C7.97961402,14.25 9.7496109,16.0200121 9.7496109,18.2000122 C9.7496109,20.3800123 7.97961402,22.1500244 5.79961395,22.1500244 C3.61961389,22.1500244 1.84960938,20.3800123 1.84960938,18.2000122 Z M3.34960938,18.2000122 C3.34960938,19.5500122 4.44961393,20.6500244 5.79961395,20.6500244 C7.14961398,20.6500244 8.2496109,19.5500122 8.2496109,18.2000122 C8.2496109,16.8500122 7.14961398,15.75 5.79961395,15.75 C4.44961393,15.75 3.34960938,16.8500122 3.34960938,18.2000122 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46945313,22.53 C1.17945313,22.24 1.17945313,21.7599414 1.46945313,21.4699414 L2.4694531,20.4699414 C2.75945309,20.1799414 3.23945066,20.1799414 3.52945065,20.4699414 C3.81945065,20.7599414 3.81945065,21.24 3.52945065,21.53 L2.52945065,22.53 C2.37945065,22.68 2.18945187,22.7499707 1.99945188,22.7499707 C1.80945188,22.7499707 1.61945313,22.68 1.46945313,22.53 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,24 L24,24 L24,0 L0,0 Z",
    id: "Vector",
    opacity: 0,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineWalletSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-wallet-search.bd1464c0281dcd62096c3f848969a2ce.svg";
export { ForwardRef as ReactComponent };